// Corte 6 (G4/G5) — listener singleton del canal SW → página.
// Doble alerta ACEPTADA por diseño: la del sistema queda intacta; esta es la rica
// (toast con acción "Responder" + ding). El mensaje del SW NUNCA trae title/body:
// el texto del toast se construye acá con i18n propio.
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useI18n } from "../../i18n";
import { playAlertSound, installAudioUnlockListeners } from "../../utils/alertSound";

export const PushForegroundListener = () => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const tRef = useRef(t);
  tRef.current = t;

  useEffect(() => {
    installAudioUnlockListeners();
    if (!("serviceWorker" in navigator)) return;

    const onMessage = (event) => {
      const msg = event.data || {};
      if (msg.kind !== "avisocar-push") return;
      const tt = tRef.current;
      playAlertSound(!!msg.is_emergency);
      const titleKey = msg.is_emergency
        ? "pushfg.emergency_title"
        : msg.event_type === "call"
        ? "pushfg.call_title"
        : msg.event_type === "chat"
        ? "pushfg.chat_title"
        : "pushfg.generic_title";
      toast(tt(titleKey), {
        description: tt("pushfg.description"),
        duration: msg.is_emergency ? 20000 : 10000,
        action: msg.url
          ? { label: tt("pushfg.respond"), onClick: () => navigate(msg.url) }
          : undefined,
        className: msg.is_emergency ? "!border-2 !border-red-500 !bg-red-50" : undefined,
      });
    };

    navigator.serviceWorker.addEventListener("message", onMessage);
    return () => navigator.serviceWorker.removeEventListener("message", onMessage);
  }, [navigate]);

  return null;
};

export default PushForegroundListener;
